import styled from 'styled-components';

export const Panel = styled.div`
  flex: ${props => props.flex};
`;

export const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;

  ${Panel} {
    margin-top: 1rem;
  }
`;
